import React from "react";
import ProductSideService from "./ProductSideService";
import BgImg from "../../assets/portfolio/bg2.png";
import OurClients from "../OurClients/OurClients";
import EmpolyeeTracking from "../../assets/product/employee-tracking-system.png";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import {
  faUserClock,
  faTasks,
  faChartLine,
  faShieldAlt,
} from "@fortawesome/free-solid-svg-icons";
import Empolyee from "../../assets/product/employee-tracking-Hero.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const EmployeeTrackingSystem = () => {
  const employeeTrackingPillars = [
    {
      title: "Real-Time Monitoring",
      description:
        "Track employee activities and attendance in real-time for accurate insights.",
      icon: faUserClock,
      bgColor: "bg-blue-100",
    },
    {
      title: "Task & Project Management",
      description:
        "Manage tasks efficiently, monitor progress, and optimize resource allocation.",
      icon: faTasks,
      bgColor: "bg-green-100",
    },
    {
      title: "Performance Analytics",
      description:
        "Evaluate performance metrics and identify growth opportunities.",
      icon: faChartLine,
      bgColor: "bg-yellow-100",
    },
    {
      title: "Data Security & Privacy",
      description:
        "Secure employee data with robust privacy controls and encryption.",
      icon: faShieldAlt,
      bgColor: "bg-red-100",
    },
  ];
  return (
    <div>
      {/* Hero section */}
      <div className="relative bg-gradient-to-r from-[#0B0F2F] to-[#12164E] text-white py-10 px-4 md:px-8 lg:px-8 overflow-hidden">
        {/* Decorative Background Circles */}
        <div className="absolute top-[-100px] left-[-100px] w-[300px] h-[300px] bg-blue-500 opacity-30 rounded-full blur-3xl z-0" />
        <div className="absolute bottom-[-150px] right-[-100px] w-[400px] h-[400px] bg-main1  opacity-20 rounded-full blur-3xl z-0" />

        <div className="relative z-10 max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Text Content */}
          <div>
            <h1 className="text-2xl md:text-4xl lg:text-4xl font-bold leading-tight text-[#8cd3fe]">
              Employee Tracking System
            </h1>
            <p className="md:mt-6  mt-4 text-gray-300 text-[15px] md:text-lg">
              Efficiently track employee performance, streamline attendance, and
              manage tasks with a powerful Employee Tracking System. Enhance
              productivity, optimize workforce management, and ensure seamless
              operations for business growth.
            </p>
            <button className="hidden md:block mt-8 px-6 py-3 rounded-full bg-main1 hover:bg-[#1c7ed6] text-white font-medium transition">
              Know More
            </button>
          </div>

          {/* Right Image/Graphic Content */}
          <div className="flex justify-center items-center">
            <img
              src={Empolyee}
              alt="employee-tracking-system"
              className="w-full max-w-md md:max-w-md lg:max-w-md"
            />
          </div>
        </div>
      </div>
      {/* second section */}
      <div className="md:py-5  py-1 ">
        <h2 className="text-lg px-2 md:px-0 md:text-3xl font-semibold text-center mt-4 mb-1 text-gray-600">
          Employee Tracking System
        </h2>
        <div className="md:w-40 w-20 h-1 bg-main mx-auto md:mb-3 mb-1 rounded-full" />

        <p className="text-center text-sm md:text-base text-gray-700 px-4 md:px-20 lg:px-40">
          Efficiently monitor employee performance, streamline attendance, and
          optimize workforce management with a robust Employee Tracking System.
        </p>

        {/* Wrapper that allows scrolling */}
        <div className="px-  md:px-5 sm:px-3 grid grid-cols-1 md:grid-cols-[2fr_1fr] gap-3 sm:gap-2 md:gap-8">
          {/* Main Content */}

          <div className="container mx-auto px-4 py-8">
            <div className="grid grid-cols-1 md:grid-cols-1 gap-8">
              {/* Image Section */}

              <div className="w-full md:order-1 order-2 max-w-3xl mx-auto px-1 sm:px-6 lg:px-8">
                <img
                  src={EmpolyeeTracking}
                  alt="EmpolyeeTracking-image"
                  className="w-full h-full  object-contain"
                />
              </div>

              {/* Text Content Section */}
              <div className="space-y-4 md:text-base  text-sm order-2 md:order-1 text-justify">
                <div>
                  <div className=" py-2">
                    <div className="space-y-3">
                      <p className="text-justify">
                        An Employee Tracking System helps businesses monitor and
                        manage employee activities, performance, and attendance.
                        By leveraging real-time data, it enhances productivity,
                        ensures accountability, and optimizes workforce
                        efficiency.
                      </p>

                      <p className="text-justify">
                        Employee Tracking enables organizations to maintain
                        detailed records of work hours, project involvement, and
                        task completion. It goes beyond simple attendance
                        logging by providing insights into employee productivity
                        and identifying areas for improvement.
                      </p>

                      <p className="text-justify">
                        Cloud-based Employee Tracking Systems ensure that data
                        is accessible anytime, anywhere. Managers can view
                        attendance logs, track project progress, and evaluate
                        performance in real-time, enabling data-driven
                        decision-making and better resource allocation.
                      </p>

                      <h4 className="text-main font-semibold text-lg md:text-xl">
                        The Benefits of Employee Tracking
                      </h4>

                      <p className="text-justify">
                        Implementing an Employee Tracking System delivers
                        substantial benefits that improve overall business
                        operations, including:
                      </p>

                      <ul className="space-y-3 pl-1 text-justify">
                        <li className="flex items-center space-x-3">
                          <FontAwesomeIcon
                            icon={faArrowRight}
                            className="text-sm text-main"
                          />
                          <span>
                            Enhanced productivity through real-time performance
                            monitoring
                          </span>
                        </li>
                        <li className="flex items-center space-x-3">
                          <FontAwesomeIcon
                            icon={faArrowRight}
                            className="text-sm text-main"
                          />
                          <span>
                            Accurate attendance and time tracking for payroll
                            efficiency
                          </span>
                        </li>
                        <li className="flex items-center space-x-3">
                          <FontAwesomeIcon
                            icon={faArrowRight}
                            className="text-sm text-main"
                          />
                          <span>
                            Improved resource management with task and project
                            insights
                          </span>
                        </li>
                        <li className="flex items-center space-x-3">
                          <FontAwesomeIcon
                            icon={faArrowRight}
                            className="text-sm text-main"
                          />
                          <span>
                            Streamlined communication and better task delegation
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Sticky Sidebar */}
          <div className="sticky  top-20 self-start  p-3  h-fit">
            <ProductSideService />
          </div>
        </div>
      </div>

      <div
        className="py-5 px-5 relative"
        style={{
          backgroundImage: `url(${BgImg})`,
          backgroundRepeat: "repeat",
          backgroundSize: "auto",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
          minHeight: "60vh",
        }}
      >
        <div className="text-center py-10 px-4">
          <h2 className="text-3xl md:text-4xl font-extrabold">
            <span className="text-black">Employee Tracking </span>
            <span className="text-sky-500"> System </span>
          </h2>

          <div className="relative w-fit mx-auto mt-2">
            <div className="h-[1px] bg-gray-300 md:w-[150px] w-[100px] mx-auto"></div>
            <div className="absolute left-1/2 -translate-x-1/2 -top-[1px] flex gap-2">
              <div className="w-8 h-[2px] bg-sky-500"></div>
              <div className="w-8 h-[2px] bg-sky-500"></div>
            </div>
          </div>

          <p className="text-gray-500 text-base mt-4">
            What You Get Using Our CRM System"
          </p>
        </div>

        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {employeeTrackingPillars?.map((pillar, index) => (
              <div
                key={index}
                className="bg-gray-50 shadow-md  overflow-hidden hover:shadow-lg transition-shadow duration-300"
              >
                <div className="p-8 text-center">
                  <div
                    className={`w-16 h-16 flex items-center justify-center rounded-full ${pillar.bgColor} mb-4 mx-auto`}
                  >
                    <FontAwesomeIcon
                      icon={pillar.icon}
                      className="text-sky-500 text-2xl"
                    />
                  </div>
                  <h5 className="md:text-lg text-base font-semibold text-gray-800 mb-3">
                    {pillar.title}
                  </h5>
                  <p className="text-gray-600 text-sm">{pillar.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* client section */}
      <div>
        <OurClients />
      </div>
    </div>
  );
};

export default EmployeeTrackingSystem;
